import AreYouSureButtons from "Components/molecule/are-you-sure-buttons"
import FormContainer from "Components/atoms/containers/form-container"
import TextInput from "Components/molecule/inputs/text-input"
import Modal from "Components/molecule/modal"
import { useEffect, useState } from "react"

interface ConfirmInputModalProps {
    isOpen: boolean
    onModalClose: () => any
    modalTitle: string
    subTitle?: string
    /** The word the user has to type before the accept button unlocks. */
    confirmWord: string
    handleAccept: () => Promise<any>
    acceptText?: string
    processingText?: string
    declineText?: string
}


const ConfirmInputModal = ({
    isOpen,
    onModalClose,
    modalTitle,
    subTitle,
    confirmWord,
    handleAccept,
    acceptText = 'Confirm',
    processingText = 'Working...',
    declineText = 'Cancel'
}: ConfirmInputModalProps) => {
    const [value, setValue] = useState<string>('')
    const [processing, setProcessing] = useState<boolean>(false)

    // A reopened modal must start locked again, otherwise the previous confirmation carries over.
    useEffect(() => {
        if (!isOpen) setValue('')
    }, [isOpen])

    const confirmed = value.trim().toLowerCase() === confirmWord.toLowerCase()

    const onAccept = async () => {
        if (!confirmed) return

        setProcessing(true)
        await handleAccept()
        setProcessing(false)
    }

    return <Modal
        isOpen={isOpen}
        onClose={onModalClose}
        title={modalTitle}
        subtitle={subTitle}
    >
        <FormContainer
            className="w-100"
            inputs={
                <TextInput
                    label={`Type "${confirmWord}" to confirm`}
                    placeholder={confirmWord}
                    value={value}
                    disabled={processing}
                    onChange={(e) => setValue(e.target.value)}
                />
            }
            buttons={
                <AreYouSureButtons
                    className="d-flex gap-2 w-100"
                    disable={processing}
                    disableAccept={!confirmed}
                    handleAccept={onAccept}
                    handleDecline={onModalClose}
                    acceptText={processing ? processingText : acceptText}
                    declineText={declineText}
                />
            }
        />
    </Modal>
}


export default ConfirmInputModal
